import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { apiCallWrapper } from "../../api/api.util";
import { HasIdOrExternalValueOrExternalIdOrServiceName } from "../../api/generic.api";
import { RoleApi } from "../../api/role/role.api";
import { IQueryFilter } from "../../model/query.filter.class";
import { Role } from "../../model/user/role.model";
import { BaseService } from "../base.service";
import { ToastService } from "../toast.service";

@Injectable({
  providedIn: "root",
})
/**
 * @description This service is used to manage role API.
 */
export class RoleService extends BaseService {
  private _roles: Role[] = [];

  constructor(
    private toastService: ToastService,
    private roleApi: RoleApi,
  ) {
    super();
  }

  async getRoles(): Promise<Role[]> {
    if (this._roles.length === 0) {
      await this._loadRoles();
    }
    return this._roles;
  }

  /**
   * Load all roles
   */
  private async _loadRoles(): Promise<void> {
    try {
      const queryFilter: IQueryFilter = new IQueryFilter();
      queryFilter.limit = 500;

      const data = await lastValueFrom(
        apiCallWrapper(this.roleApi.list(queryFilter), {
          toastService: this.toastService,
          action: "Fetching roles",
        }),
      );

      const roles = this.inflateModel<
        Role,
        Role & HasIdOrExternalValueOrExternalIdOrServiceName<string>
      >(Role, data);

      if (roles) {
        this._roles = roles.rows;
      }
    } catch (error) {
      throw error;
    }
  }
}
